import Observable, { PENDING } from './observable';
export default class Subject extends Observable {
    constructor() {
        super((observer) => {
            this.subjectObservers.push(observer);
            if (this.currentValue !== PENDING) {
                observer.next(this.currentValue);
            }
            return () => {
                this.subjectObservers.splice(this.subjectObservers.indexOf(observer), 1);
            };
        });
        this.subjectObservers = [];
    }
    complete() {
        // tslint:disable-next-line:no-increment-decrement
        for (let i = 0; i < this.subjectObservers.length; i++) {
            this.subjectObservers[i].complete();
        }
    }
    next(value) {
        // tslint:disable-next-line:no-increment-decrement
        for (let i = 0; i < this.subjectObservers.length; i++) {
            this.subjectObservers[i].next(value);
        }
    }
}
//# sourceMappingURL=subject.js.map